import React from 'react';
import { View } from '@smarterservices/smarter-ui';
import { usePaneMaxHeight } from '../../hooks/usePaneMaxHeight';

/**
 * SinglePane
 *
 * A simple layout with everything in one scrollable column.
 *
 * Props:
 *   - children (ReactNode): The single‐pane content.
 */
const SinglePane = ({ children, maxHeightPercentage = 75, minHeight = 300, offset = 0 }) => {
  const maxHeight = usePaneMaxHeight({
    offset,
    maxHeightPercentage,
    minHeight,
  });
  return (
    <View
      as="div"
      className="single-pane"
      display="block"
      overflowY="auto"
      padding="small"
      width="100%"
      height="100%"
      maxHeight={maxHeight}
    >
      {children}
    </View>
  );
};

export default SinglePane;
